import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData, trueFalseToBoolean } from '../../../../../utils/helpers.utils';
import { actions } from 'react-redux-form';
import {
    //model
    wirelineOtherRequestModel
    //action
    , resetWirelineOtherRequestForm
    , setOtherRequestOptions
    , setSubscriptionDetails
    , setFormSubmitted
    , setResetLoading
    , setResetApprover
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-other-request.settings';
import { onSelectedApprover, resetWirelineApprover } from './new-circuit/new-circuit-subscription.reducer';

export const otherRequestModelAInitialState = wirelineOtherRequestModel;

const defaultState = () => ({
    otherOptions: []
    , subscription: {}
    , formSubmitted: false
    , isResetLoading: false
    , isResetApprover: false
});

const initialState = defaultState();


export const wirelineOtherRequestActions = {
    onUpdateForm: () => async (dispatch, state) => {

        const { requestData } = state().requestDetail;
        const { subscriptionList, employeeList, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { otherOptions } = state().wirelineOtherRequestRequest;

        await updateSubscriptionSelect(requestData.Circuit.CircuitCode, subscriptionList, dispatch, state);
        
        dispatch(actions.change('wirelineOtherRequestFormA.otherRequestTypeId', requestData.Order.RequestType.RequestTypeID.toString()));
        dispatch(actions.change('wirelineOtherRequestFormA.expediteRequest', requestData.BusinessWireline.ExpediteRequest.toString()));
        dispatch(actions.change('wirelineOtherRequestFormA.businessJustification', requestData.BusinessJustification.BusinessJustification));
        dispatch(actions.change('wirelineOtherRequestFormA.additionalInformation', requestData.BusinessJustification.AdditionalInformation));

        await updateOnEmployeeSelect(requestData.WireLineApprover.EmployeeId, employeeList, dispatch, state);
    },
    onSubscriptionSelect: (value, propsName, objects) => async (dispatch, state) => {

        const { wirelineOtherRequestFormA } = state().form;

        if (value === '') {    
            dispatch(actions.reset('wirelineOtherRequestFormA.circuitCode'));
            dispatch(actions.reset('wirelineOtherRequestFormA.circuitId'));   
            dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', ''));
            dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', 0));
            dispatch(onSelectedApprover(''))
            dispatch({ type: setResetApprover, data: true });
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
            if(objects) {
                var obj = objects.find(o => o[propsName] === value);

                    if (obj != null) {

                        // Initial load - populate the circuit without clearing existing data
                      if (wirelineOtherRequestFormA.circuitId == 0) {
                            dispatch(actions.change(
                                'wirelineOtherRequestFormA.circuitCode',
                                value
                            ));

                            dispatch(actions.change(
                                'wirelineOtherRequestFormA.circuitId',
                                obj.CircuitId
                            ));

                            dispatch({
                                type: setSubscriptionDetails,
                                data: obj
                            });
                        }

                        // Actual subscription change
                        else if (obj.CircuitId != wirelineOtherRequestFormA.circuitId) {
                            dispatch(actions.change('wirelineOtherRequestFormA.circuitCode', value));
                            dispatch(actions.change('wirelineOtherRequestFormA.circuitId', obj.CircuitId));
                            dispatch({ type: setSubscriptionDetails, data: obj });
                            dispatch(actions.change('wirelineOtherRequestFormA.vendorDetailId', obj.VendorDetailId));

                            dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', ''));
                            dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', 0));
                            dispatch(onSelectedApprover(''));
                            dispatch({ type: setResetApprover, data: true });
                        }
                    }
            }
            else {
                dispatch(actions.reset('wirelineOtherRequestFormA.circuitCode'));
                dispatch(actions.reset('wirelineOtherRequestFormA.circuitId'));
                dispatch(actions.reset('wirelineOtherRequestFormA.employeeEmail', ''));
                dispatch(actions.reset('wirelineOtherRequestFormA.wireLineApproverId', 0));
                dispatch(onSelectedApprover(''))
                dispatch({ type: setResetApprover, data: true });
                dispatch({ type: setSubscriptionDetails, data: {} });
            }
        }
    }
    , onEmployeeSelect: (value, propsName, objects) => (dispatch, state) => {

        const { wirelineOtherRequestFormA } = state().form;

        if (value === '') {
            dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', ''));
            dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', 0));
            dispatch(onSelectedApprover(''));
            dispatch({ type: setResetApprover, data: true });
        } else {
            const obj = objects?.find(o => o[propsName] === value);

            if (obj != null) {
                if (parseInt(obj.EmployeeId) !== parseInt(wirelineOtherRequestFormA.wireLineApproverId)) {
                    dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', value));
                    dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', obj.EmployeeId));
                }
                dispatch(onSelectedApprover(value, obj.EmployeeId));
                setTimeout(function () {
                    dispatch({ type: setResetApprover, data: false });
                }, 5)
            }
        }
    }
    , onChangeExpedite: (model, value) => (dispatch) => {

        dispatch(actions.change(model, value));

        if (!trueFalseToBoolean(value)) {
            dispatch(actions.change('wirelineOtherRequestFormA.businessJustification', ''));
        }
    }
    , submitRequest: (date) => async (dispatch, state) => {

        const { wirelineOtherRequestFormA } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { subscription } = state().wirelineUpgradeCircuitRequest;
        const { requestData, isAmending } = state().requestDetail;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.employeeID = requestOnBehalfData.EmployeeId;
        }

        var data = {
            ...userData
            , requestTypeId: requestTypeId
            , wirelineOtherRequest: {
                ...wirelineOtherRequestFormA
                , requestInBehalfId: userData.requestInBehalfId
            },  ChangeRequestModel: {
                ...userData
                , ...wirelineOtherRequestFormA
                , CircuitId: wirelineOtherRequestFormA.circuitCode ? wirelineOtherRequestFormA.circuitId : 0
                , vendorDetailId: wirelineOtherRequestFormA.vendorDetailId ? wirelineOtherRequestFormA.vendorDetailId : 0
                , BusinessJustification: wirelineOtherRequestFormA.businessJustification
                , AdditionalInformation: wirelineOtherRequestFormA.additionalInformation
                , RequestTypeId: 0
                , NoEmail: true
            }, IsAmending: isAmending
            , OrderId: isAmending ? requestData.Order.OrderId : 0
            , CircuitId: isAmending ? requestData.CircuitId : 0
            , CircuitOrderId: isAmending ? requestData.CircuitOrderId : 0
            , OrderHistoryId: isAmending ? requestData.OrderHistoryId : 0
            , OrderInfoId: isAmending ? requestData.OrderInfoId : 0
        }

        var res = await httpPost('external/wirelineOrderRequest', data);

        if (res.Success) {
            dispatch({ type: setFormSubmitted, data: true });
        }
        else {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;
    }
    , fetchOtherOptions: () => (dispatch) => {
        fetchOtherRequestWirelineTypes(dispatch);
    }
    , resetWirelineOtherRequestForm: (isResetRequestOnBehalf = false) => (dispatch) => {
        resetForm(dispatch);
        dispatch({ type: setResetLoading, data: true });
        dispatch(actions.reset('wirelineOtherRequestFormA.circuitCode'));
        dispatch(actions.reset('wirelineOtherRequestFormA.circuitId'));
        dispatch(actions.reset('wirelineOtherRequestFormA.employeeEmail'));
        dispatch(actions.reset('wirelineOtherRequestFormA.wireLineApproverId'));
        dispatch(actions.reset('wirelineOtherRequestFormA'));
        dispatch(onSelectedApprover(''))
        dispatch({ type: setResetApprover, data: true });
         setTimeout(function () {
            dispatch({ type: setResetLoading, data: false });
         }, 1);

    }
}

async function updateOnEmployeeSelect(value, employeeList, dispatch, state) {
    const obj = employeeList?.find(o => parseInt(o.EmployeeId) === parseInt(value));

    if (obj != null) {
        dispatch(actions.change('wirelineOtherRequestFormA.employeeEmail', obj.LastFirstName));
        dispatch(actions.change('wirelineOtherRequestFormA.wireLineApproverId', obj.EmployeeId));
        dispatch(onSelectedApprover(obj.LastFirstName, obj.EmployeeId))
        dispatch({ type: setResetApprover, data: false });
    }
}

async function updateSubscriptionSelect(circuitCode, subscriptionList, dispatch, state) {

    var obj = subscriptionList.find(o => o["CircuitCode"] === circuitCode);

    dispatch(actions.change('wirelineOtherRequestFormA.circuitCode', circuitCode));
    dispatch(actions.change('wirelineOtherRequestFormA.circuitId', obj?.CircuitId));
    dispatch(actions.change('wirelineOtherRequestFormA.vendorDetailId', obj?.VendorDetailId));
    dispatch({ type: setSubscriptionDetails, data: obj });

}

function resetForm(dispatch) {

    dispatch(actions.reset('wirelineOtherRequestFormA'));
    dispatch(actions.reset('wirelineOtherRequestFormA.employeeEmail'));
    dispatch(actions.reset('wirelineOtherRequestFormA.wireLineApproverId'));
    dispatch(onSelectedApprover(''))
    setTimeout(function () {
        dispatch({ type: setResetLoading, data: false });
    }, 5);
    dispatch({ type: setFormSubmitted, data: false });
    //dispatch({ type: resetWirelineChangeVendorForm, vendor: defaultState.vendorDetails });
}

async function fetchOtherRequestWirelineTypes(dispatch, defaultDisplay = true) {

    var res = await httpGet('external/otherRequest/getOtherRequestWirelineTypes/'
        + defaultDisplay + '/');

    dispatch({ type: setOtherRequestOptions, data: res });

}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setOtherRequestOptions:
            return {
                ...state
                , otherOptions: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            };
        case setResetApprover:
            return {
                ...state
                , isResetApprover: action.data
            };
        default: return state;
    }
}